import { applicationFeedbackMessage } from "./sourceChangeApplicationFeedback.js";

const clock = (value) => {
  const match = String(value || "").match(/(?:T|^)(\d{2}):(\d{2})/);
  return match ? `${Number(match[1])} h${match[2] === "00" ? "" : ` ${match[2]}`}` : String(value || "");
};

export function clientSavedConstraintMessage(result) {
  const client = result?.client_correspondence || {};
  const name = client.client_name || client.correspondence_name || "la meunerie";
  const fields = new Set(result?.audit?.changed_fields || []);
  const changes = [];
  for (const [field, label] of [["loading_opening_time", "Ouverture"], ["loading_closing_time", "Fermeture"]]) {
    if (fields.has(field)) changes.push(client[field]
      ? `${label} de ${name} sauvegardée à ${clock(client[field])}.`
      : `Restriction ${field === "loading_opening_time" ? "d’ouverture" : "de fermeture"} de ${name} retirée.`);
  }
  if (fields.has("meunerie_loading_extra_minutes")) changes.push(`Temps supplémentaire de chargement de ${name} sauvegardé : ${client.meunerie_loading_extra_minutes || 0} min.`);
  return changes.join(" ");
}

export async function prepareSavedClientDispatch({ result, dispatchDate, prepareClient,
  reportProgress, setCompletionToast, updateLoadingToast }) {
  const savedMessage = clientSavedConstraintMessage(result);
  const handled = { ...result, _data_manager_success_toast_handled: true };
  if (!dispatchDate) {
    reportProgress("dispatch", "warning");
    setCompletionToast({ title: "Journée de Dispatch à sélectionner", type: "warning", duration: 9000,
      message: `${savedMessage} Sélectionnez une journée pour appliquer la modification au Dispatch.` });
    return handled;
  }
  let warning = false;
  const messages = [];
  reportProgress("dispatch");
  for (const [dispatchPeriod, label] of [["day", "Jour"], ["evening", "Soir"]]) {
    updateLoadingToast({ title: "Actualisation du Dispatch", message: `${savedMessage} Vérification du Dispatch ${label}…` });
    try {
      const preparation = await prepareClient({ correspondenceId: result.client_correspondence.correspondence_id,
        expectedUpdatedAt: result.client_correspondence.updated_at, dispatchDate, dispatchPeriod });
      if (!Array.isArray(preparation?.results)) throw new Error("Le résultat de la préparation est incomplet.");
      const entries = preparation.results;
      for (const entry of entries) {
        const truckLabel = entry.truck_label || entry.truck_id;
        const prefix = truckLabel ? `${label} · ${truckLabel}` : label;
        if (entry.outcome === "applied") messages.push(`${prefix} : tournée actualisée.`);
        else if (entry.outcome === "confirmation_required") {
          warning = true;
          const count = new Set((entry.proposed_groups || []).flatMap((group) => group.order_ids || [])).size;
          messages.push(`${prefix} : la suspension de ${count} commande${count > 1 ? "s" : ""} reste à confirmer dans Mise à jour.`);
        } else {
          warning = true;
          messages.push(`${prefix} : ${applicationFeedbackMessage(entry.application_feedback) || entry.detail || entry.message || "actualisation à vérifier dans Mise à jour."}`);
        }
      }
      if (!entries.length) messages.push(`${label} : ${preparation.message || "aucun changement en attente."}`);
    } catch (error) {
      // A lost response can follow a commit. Reconcile through reads, never repeat the POST.
      warning = true;
      messages.push(`${label} : ${error?.message || "résultat de l’actualisation indisponible."}`);
    }
  }
  reportProgress("dispatch", warning ? "warning" : "completed");
  setCompletionToast({ title: warning ? "Dispatch à vérifier dans Mise à jour" : "Dispatch actualisé",
    type: warning ? "warning" : "success", duration: warning ? 12000 : 8000,
    message: `${savedMessage} ${messages.join(" ")}` });
  return handled;
}
